import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import { CommandBarButton, DirectionalHint, TooltipHost } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { SelectedItem } from '@bingads-webui-campaign-react/pill-item-components';

const getStyles = (_components, { palette }) => ({
  RemoveAllButton: {
    height: 32,
    color: palette.themePrimary,
  },
  SelectedBrandsTagsHeader: {
    padding: 8,
  },
  SelectedBrandsTags: {
    display: 'flex',
    flexWrap: 'wrap',
    gridGap: 8,
  },
  TooltipContent: {
    padding: 8,
    '& p': {
      margin: 0,
    },
  },
});

export const SelectedBrandsTags = ({
  className,
  selectedOptions,
  onRemoveAll,
  onRemoveItem,
  isAwaysDisplayHeader,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  const onRenderSelectedItemText = useCallback(({ item, text }) => (
    <TooltipHost
      directionalHint={DirectionalHint.rightCenter}
      tooltipProps={{
        onRenderContent: () => (
          <div className={classes.TooltipContent}>
            <p className="brand-name">{`${item.name} (${item.key})`}</p>
            <p className="brand-link">{item.link}</p>
          </div>
        ),
      }}
    >
      <span className="selected-item-text">{text}</span>
    </TooltipHost>
  ), [classes.TooltipContent]);

  return (
    <div className={classNames(classes.SelectedBrandsTagsContainer, 'selected-brands-tags-container', className)}>
      {(isAwaysDisplayHeader || !_.isEmpty(selectedOptions)) && (
        <div className={classNames(classes.SelectedBrandsTagsHeader, 'selected-brands-tags-header')}>
          <span className="selected-count">{selectedOptions ? selectedOptions.length : 0} {i18n.getString(_TL_('Brands'))}</span>
          {!_.isEmpty(selectedOptions) && (
            <CommandBarButton
              className={classNames(classes.RemoveAllButton, 'remove-all-button')}
              text={i18n.getString(_TL_('Remove all'))}
              onClick={onRemoveAll}
            />
          )}
        </div>
      )}
      <div className={classNames(classes.SelectedBrandsTags, 'selected-brands-tags')}>
        {!_.isEmpty(selectedOptions) && selectedOptions.map((item, index) => (
          <SelectedItem
            key={item.key}
            itemText={`${item.name} (${item.key})`}
            onRenderText={text => onRenderSelectedItemText({ item, text })}
            itemIndex={index}
            onDelete={() => onRemoveItem(item)}
          />
        ))}
      </div>
    </div>
  );
};

SelectedBrandsTags.propTypes = {
  className: PropTypes.string,
  selectedOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
  })).isRequired,
  onRemoveAll: PropTypes.func.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  isAwaysDisplayHeader: PropTypes.bool,
};

SelectedBrandsTags.defaultProps = {
  className: undefined,
  isAwaysDisplayHeader: false,
};
